import {IOptionItemChoice, IUserSelections} from "@bimaire/optionslib";

import { useUnrealConfig } from "./UnrealConfig";
import UnrealClient from "./UnrealClient";
import {useEffect, useReducer} from "react";
import {useVisualizerSession} from "../components/visualizer/VscVisualizerSession";



function loadingReducer(numOperations:number, oper: "increment" | "decrement"): number {
  if (oper === "increment") {
    return numOperations + 1;
  }
  else {
    return numOperations - 1;
  }
}
/**
 * This hook connects the selections to an Unreal visualizer application
 * @param userSelections Selections made by the user
 * @param lot the lot id (e.g. GenLot)
 */
export function useUnreal(
  userSelections: IOptionItemChoice[],
  lot: string
) {
    const visualizer = useVisualizerSession();

    const configs = useUnrealConfig();
    const unrealClient =
        configs !== null && new UnrealClient(visualizer, configs);

    const [numOperations, loadingDispatch] = useReducer(loadingReducer, 0);
    useEffect(() => {

        if (unrealClient === false) return;
        loadingDispatch("increment");

        unrealClient.updateOptions(userSelections, lot)
            .catch((err) => {
            console.log("Unable to connect to unreal! " + err); // TODO
        }).finally(() => loadingDispatch("decrement"));
    }, [JSON.stringify(userSelections), configs]);


    return {isLoading: numOperations > 0};
}
